import { useCallback } from 'react';
import AddAccountModal from 'features/accounts/components/AddAccountModal';
import Amplitude from 'utils/amplitude';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import usePlaidLink from './usePlaidLink';
const useAddAccount = () => {
    const { navigateDeprecated } = useMainStackNavigation();
    const plaidLink = usePlaidLink();
    const addAccount = useCallback(() => {
        Amplitude.logEvent('Accounts.OpenAddAnAccount');
        AddAccountModal.show({
            navigate: navigateDeprecated,
            onOpenPlaid: plaidLink,
            onAddOffline: () => {
                navigateDeprecated('PickAccountType', {});
            },
            onAddProperty: () => {
                navigateDeprecated('Property', {});
            },
        });
    }, [plaidLink]);
    return addAccount;
};
export default useAddAccount;
